import { Node } from '@tiptap/vue-3';

/**
 * Basic block and nestable div node extension.
 */
export const SectionExtension = Node.create({
  name: 'section',
  group: 'block',
  content: 'block+',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'section',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['section', HTMLAttributes, 0];
  },
});
